import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Container, Reveal, SectionLabel } from "../components/primitives";
import { Skeleton } from "../components/ui/skeleton";
import Seo from "../components/Seo";
import api from "../lib/api";

export default function Portfolio() {
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.get("/portfolio").then((r) => setItems(r.data)).catch(() => setItems([]));
  }, []);

  return (
    <div data-testid="portfolio-page" className="pt-32">
      <Seo page="portfolio" />
      <Container>
        <Reveal>
          <SectionLabel>Portfolio</SectionLabel>
          <h1 className="mt-3 font-display text-4xl sm:text-5xl font-bold tracking-tighter text-[#F3EDDC] max-w-3xl">
            Concept projects across local industries
          </h1>
          <p className="mt-5 text-lg text-[#B7AF98] max-w-2xl">
            These are fictional concept projects created to showcase our design and development capabilities — not real clients.
          </p>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-8 pb-24">
          {items === null
            ? Array.from({ length: 4 }).map((_, i) => <Skeleton key={i} className="h-96 rounded-3xl" />)
            : items.map((p, i) => (
                <Reveal key={p.slug} delay={i * 70}>
                  <Link
                    to={`/portfolio/${p.slug}`}
                    data-testid={`portfolio-card-${p.slug}`}
                    className="group block rounded-3xl overflow-hidden border border-white/10 bg-[#141414] hover:-translate-y-1 transition-transform duration-300 shadow-[0_8px_32px_rgba(0,0,0,0.04)]"
                  >
                    <div className="relative h-72 overflow-hidden">
                      <img src={p.hero_image} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                      <span className="absolute top-4 left-4 rounded-full bg-[#141414]/90 backdrop-blur px-3 py-1 text-xs font-semibold text-[#D2CAB2]">Concept · {p.industry}</span>
                    </div>
                    <div className="p-7">
                      <h3 className="font-display text-2xl font-bold text-[#F3EDDC]">{p.title}</h3>
                      <p className="mt-2 text-[#B7AF98]">{p.tagline}</p>
                      <span className="mt-5 inline-flex items-center gap-1 text-sm font-semibold text-[#C9A227]">
                        View concept <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
                      </span>
                    </div>
                  </Link>
                </Reveal>
              ))}
        </div>
      </Container>
    </div>
  );
}
